import { RouteConfig } from '@abaco/web-common/src/app';

const MODULE_BASE_PATH = "/assets";

const routes: RouteConfig[] = [
    {
        name: "workers",
        path: `${MODULE_BASE_PATH}/workers`,
        component: () => import("./components/tiles/worker/WorkerTileset.vue"),
        meta: {
            navbarItems: [{component: "farm-select-nav-bar-item", props: { ["is-required"]: true }}]
        }
    },
    {
        name: "materials",
        path: `${MODULE_BASE_PATH}/assets`,
        component: () => import("./components/tiles/assetsMenu/AssetsMenuTileset.vue"),
        meta: {
            navbarItems: [{component: "farm-select-nav-bar-item", props: { ["is-required"]: true }}]
        }
    },
    {
        name: "equipments",
        path: `${MODULE_BASE_PATH}/equipments`,
        component: () => import("./components/tiles/equipments/EquipmentMenuTileset.vue"),
        meta: {
            navbarItems: [{component: "farm-select-nav-bar-item", props: { ["is-required"]: true }}]
        }
    },
    {
        name: "buildings",
        path: `${MODULE_BASE_PATH}/buildings`,
        component: () => import("./components/tiles/buildings/BuildingMenuTileset.vue"),
        meta: {
            navbarItems: [{component: "farm-select-nav-bar-item", props: { ["is-required"]: true }}]
        }
    },
    {
        name: "assets-administration",
        path: `${MODULE_BASE_PATH}/administration`,
        component: () => import("./components/AssetsSingleTileContainer.vue"),
        props: {tileId: "staff-list-tile"},
        meta: { navbarItems: [ "farm-select-nav-bar-item"] }
    },
];

export default routes;
